module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD7SURBVHgB5ZXhEYIwDIVznAM4ghvoCI7gCGwgG4ATgBOAIzgBK7hB3aA6QQxH0QpJbUF+8d3loPBe0+SOALAIELHCITX8C9pMMwk0jIGM6yZ6a4kvnW8CZcwlxU5oD1qag9Hon20jQYzTicHRGoXTaSp5tyuychwpNo4C7xRnipO5l2g2T7gKCsepCkafhehdJgUC9K723twyVb4G5kADbcT4HjAXdIKcKVk79IrRpyGbd+SMPnXos063sjxPkEnIdKDr1ay3FHsIAdsPTeN0FEpzCeccFVaSGttKSvwMMolGYw9E5d2uXuskwse1kHD0DycCP27Mswssghd3mz5pAKc+7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Images/settingwhticn.png
// module id = 1173
// module chunks = 0